import React, { useState, useEffect } from 'react';
import { getFleet } from '../traccar';
import { getIdle, resetIdle, fmtIdle } from '../idleStore';

export default function DashboardPage() {
  const [fleet, setFleet] = useState([]);
  const [idle, setIdle] = useState({});
  const [error, setError] = useState(null);

  const refresh = async () => {
    try { setFleet(await getFleet()); setError(null); } catch (e) { setError(e.message); }
    setIdle(getIdle());
  };
  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 10000);
    return () => clearInterval(t);
  }, []);

  const moving = fleet.filter((v) => v.motion).length;
  const idlingNow = Object.values(idle).filter((s) => s.idlingNow).length;
  const totalIdleToday = Object.values(idle).reduce((s, v) => s + (v.todaySec || 0), 0);

  const stat = (label, value, color) => (
    <div className="card" style={{ textAlign: 'center', padding: '18px' }}>
      <div style={{ fontFamily: 'Poppins, sans-serif', fontSize: '30px', fontWeight: 700, color }}>{value}</div>
      <div style={{ fontSize: '11px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</div>
    </div>
  );

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>📊 Dashboard</h1>
        <p>{error ? `🔴 ${error}` : 'Fleet overview and idle-time tracking.'}</p>
      </div>

      <div className="grid grid-4" style={{ marginBottom: '24px' }}>
        {stat('Vehicles', fleet.length, '#0f172a')}
        {stat('Moving now', moving, '#15803d')}
        {stat('Idling now', idlingNow, '#b45309')}
        {stat('Idle today (fleet)', fmtIdle(totalIdleToday), '#b91c1c')}
      </div>

      <div className="card" style={{ padding: 0, overflowX: 'auto' }}>
        <div style={{ padding: '14px 18px', borderBottom: '1px solid #e5e7eb', fontFamily: 'Poppins, sans-serif', fontWeight: 700, color: '#0f172a' }}>
          🕒 Idle Time by Vehicle
        </div>
        <table style={{ margin: 0 }}>
          <thead>
            <tr>
              <th>Vehicle</th><th>Status</th><th style={{ textAlign: 'right' }}>Stopped for</th><th style={{ textAlign: 'right' }}>Idling now</th>
              <th style={{ textAlign: 'right' }}>Idle today</th><th style={{ textAlign: 'right' }}>Idle total</th><th></th>
            </tr>
          </thead>
          <tbody>
            {fleet.map((v) => {
              const s = idle[v.id] || {};
              const idleSession = s.idlingNow ? Math.max(0, (s.stoppedOnSec || 0) - 300) : 0;
              return (
                <tr key={v.id}>
                  <td style={{ fontWeight: 600 }}>{v.name}</td>
                  <td>
                    {s.idlingNow
                      ? <span style={{ fontSize: '11px', fontWeight: 700, padding: '2px 10px', borderRadius: '999px', background: '#fffbeb', color: '#b45309' }}>IDLING</span>
                      : s.moving
                        ? <span style={{ fontSize: '11px', fontWeight: 700, padding: '2px 10px', borderRadius: '999px', background: '#f0fdf4', color: '#15803d' }}>MOVING</span>
                        : <span style={{ fontSize: '11px', fontWeight: 700, padding: '2px 10px', borderRadius: '999px', background: '#f1f5f9', color: '#64748b' }}>STOPPED</span>}
                  </td>
                  <td style={{ textAlign: 'right', color: '#334155', fontWeight: 600 }}>{s.moving ? '—' : fmtIdle(s.stoppedSec)}</td>
                  <td style={{ textAlign: 'right', color: s.idlingNow ? '#b45309' : '#94a3b8', fontWeight: 600 }}>{s.idlingNow ? fmtIdle(idleSession) : '—'}</td>
                  <td style={{ textAlign: 'right', fontWeight: 600 }}>{fmtIdle(s.todaySec)}</td>
                  <td style={{ textAlign: 'right', fontWeight: 700 }}>{fmtIdle(s.totalSec)}</td>
                  <td style={{ textAlign: 'center' }}>
                    <button onClick={() => { if (window.confirm(`Reset idle counters for ${v.name}?`)) { resetIdle(v.id); setIdle(getIdle()); } }}
                      style={{ background: '#f1f5f9', color: '#475569', padding: '4px 10px', borderRadius: '6px', fontSize: '11px', fontWeight: 700 }}>Reset</button>
                  </td>
                </tr>
              );
            })}
            {fleet.length === 0 && <tr><td colSpan={7} style={{ textAlign: 'center', color: '#94a3b8', padding: '24px' }}>No vehicles reporting.</td></tr>}
          </tbody>
        </table>
      </div>

      <p style={{ fontSize: '11px', color: '#94a3b8', marginTop: '10px' }}>
        Idle = stopped with the engine on. Counting starts after 5 continuous minutes stopped (so brief stops don't count). "Stopped for" shows time since the vehicle last moved. An hourly idle warning fires for any vehicle idling an hour straight. Time accumulates while the dashboard is open; it runs continuously once deployed to the server.
      </p>
    </div>
  );
}
